export const defaultScopeId = "v3.workflowinstance";
export const contextKey = "workflowinstance";

export const CURRENT_WORKFLOWINSTANCE_REQUESTED = "WORKFLOWINSTANCE/CURRENT_WORKFLOWINSTANCE_REQUESTED";
export const CURRENT_WORKFLOWINSTANCE_SUCCEEDED = "WORKFLOWINSTANCE/CURRENT_WORKFLOWINSTANCE_SUCCEEDED";
export const CURRENT_WORKFLOWINSTANCE_FAILED = "WORKFLOWINSTANCE/CURRENT_WORKFLOWINSTANCE_FAILED";

// eslint-disable-next-line complexity, max-statements
export default (
    state = {
        currentWorkflowinstance: null,
        errors: [],
        hasInitialData: false,
        loading: 0,
    },
    { type, data }
) => {
    switch (type) {
    case CURRENT_WORKFLOWINSTANCE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case CURRENT_WORKFLOWINSTANCE_SUCCEEDED: {
        --state.loading;
        state.hasInitialData = true;
        state.currentWorkflowinstance = data;
        return state;
    }
    case CURRENT_WORKFLOWINSTANCE_FAILED: {
        --state.loading;
        state.errors.push(data);
        return state;
    }
    default:
        return state;
    }
};

export const requestCurrentWorkflowinstance = (data, resolve, reject) => ({ type: CURRENT_WORKFLOWINSTANCE_REQUESTED, data, resolve, reject });
export const succeedCurrentWorkflowinstance = data => ({ type: CURRENT_WORKFLOWINSTANCE_SUCCEEDED, data });
export const failCurrentWorkflowinstance = data => ({ type: CURRENT_WORKFLOWINSTANCE_FAILED, data });

